export default __webpack_public_path__ + "static/media/Letters3_12.114bb498.png";